import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ValidationGroup from 'helpers/validation';
import moment from 'moment';
import {AddressComplete} from 'components/forms';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import Dealer from 'models/dealer';

class Record extends Component {
  static propTypes = {
    accountNumber: PropTypes.string.isRequired,
    address: PropTypes.string,
    i: PropTypes.number.isRequired,
    id: PropTypes.any.isRequired,
    lastAnalysis: PropTypes.object,
    name: PropTypes.string,
    organization: PropTypes.string,
    previouslyAttempted: PropTypes.bool.isRequired,
    saveAddress: PropTypes.func.isRequired,
    setAttempted: PropTypes.func.isRequired,
    initialAddress: PropTypes.any.isRequired,
    intl: intlShape.isRequired,
    dealer: PropTypes.instanceOf(Dealer).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      attempting: false,
    };

    this.group = new ValidationGroup(this.save.bind(this));
  }

  cancel = () => {
    this.setState({
      attempting: false,
    });

    this.ac.getWrappedInstance().reset();
  };

  focusHandler = () => {
    this.setState({
      attempting: true,
    });
    this.props.setAttempted(this.props.id);
  };

  save() {
    var acAddress = this.ac.getWrappedInstance().getValue();

    this.props.saveAddress(this.props.initialAddress.id, acAddress.addressCompleteID ? acAddress : this.props.initialAddress);
  }

  verify = () => {
    this.ac.getWrappedInstance().focus();
  };

  render() {
    const {name, address, id, i, previouslyAttempted, accountNumber, lastAnalysis, dealer} = this.props;
    let {formatMessage} = this.props.intl;

    return <tr>
      <td>{accountNumber}</td>
      <td>{lastAnalysis ? moment(lastAnalysis).format('ll') : <FormattedMessage id='general.none' />}</td>
      <td>{name}</td>
      <td style={{textAlign: 'right'}}>
        {previouslyAttempted ? <i className='bl bl-attention blue'
                                  style={{color: '#0093d6'}}/> : null}
      </td>
      <td>
        <AddressComplete value={address}
                         onFocus={this.focusHandler}
                         required
                         country={dealer.country}
                         group={this.group}
                         ref={x => this.ac = x}
                         id={id + '-address-complete'}
                         delay={i * 50}/>
      </td>
      <td>
        {this.state.attempting ?
          <span>
            <button className='btn btn-link bold'
                    onClick={this.group.validate}><FormattedMessage id='general.save' /></button> | <button className='btn btn-link'
                                                                                                           onClick={this.cancel}>
                      <FormattedMessage id='general.cancel' />
                    </button>
          </span> :
          <button className='btn btn-link'
                  onClick={this.verify}><FormattedMessage id={previouslyAttempted ? 'general.reverify' : 'general.verify'} /></button>}
      </td>
    </tr>;
  }
}

export default injectIntl(Record);
